import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {AlertOPEEnum} from "./AlertOPEEnum";

class O {

}

class I {

  partitionId!: number;
  id!: number;

}

export class DelMetricInstanceAlertCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(AlertOPEEnum.DelMetricInstanceAlert);
    this.i = new I();
    this.o = new O();
  }
}
